import React, { useMemo } from 'react'
import { Alert, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { DeletedAccountError, DisabledAccountError } from '../errors'
import logError from '../services/logError'

const errorClassMap = {
  DISABLED_BY_ADMIN: DisabledAccountError,
  PENDING_DELETE: DeletedAccountError,
  // other cases not handled:
  // INCOMPLETE_REGISTRATION (not possible for IdP)
  // NOT_PARENTAL_CONSENTED_EMAIL (not possible for IdP)
  // NOT_PARENTAL_CONSENTED_SMS (not possible for IdP)
  // NOT_ACTIVATED_EMAIL (not possible for IdP)
  // NOT_ACTIVATED_SMS (not possible for IdP)
  // NOT_ACTIVATED_EITHER (not possible for IdP)
  // TOMBSTONED, (not implemented yet by the system)
  // DECEASED probably should have a message for this
}

export default function ErrorFromUrl() {
  const { t } = useTranslation()
  const errorMessage = useMemo(() => {
    const code = new URLSearchParams(window.location.search).get('error')
    if (!code) {
      return null
    }
    const ErrorClass = errorClassMap[code]
    if (ErrorClass) {
      return new ErrorClass().render()
    }
    logError(`Unknown login error in URL ${code}`)
    return t('generic.error', 'Something went wrong, try again later')
  }, [t])
  if (!errorMessage) {
    return null
  }
  return (
    <>
      <Alert type="error" dismissable outlined>
        {errorMessage}
      </Alert>
      <Separator />
    </>
  )
}
